<template>
  <div class="page-coming-soon">
    <ul>
      <li class="logo-img">
        <img src="@/assets/img/dragons_logo.png" alt="dragons_logo">
      </li>
      <li class="logo-text">
        <img src="@/assets/img/logo_text.png" alt="logo_text">
      </li>
      <li>
        <p class="title">{{ titleText }}</p>
        <p>{{ descriptionText }}</p>
      </li>
      <li class="pt">
        <p>{{descriptionTextSub}}</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PageComingSoon',
  props: {
    titleText: {
      type: String,
      default: '페이지 준비중' // 기본 텍스트
    },
    descriptionText: {
      type: String,
      default: '해당 페이지는 준비중입니다.' // 기본 설명 텍스트
    },
    descriptionTextSub: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      tabList: [],
    }
  },
  mounted () {
  },
  methods: {

  }
}
</script>
